import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, Stack } from '@mui/material'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import NumberField from '../../../../components/forms/NumberField'
import RadioButtons from '../../../../components/forms/RadioButtons'
import Select from '../../../../components/forms/Select'
import { getSetting } from '../../../../utils/SettingUtils'
import DtoAccountSettings from '../../../dto/DtoAccountSettings'
import { SHOW_SANDRE_CODE, SHOW_INSEE_CODE } from 'account/constants/AccountSettingsConstants'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'

const UserOptionPanel = ({ accountUserSettings, changeSetting }) => {
    const {
        accountUser,
        producers,
        contributors,
        contacts,
        status,
        qualifications,
        supports,
    } = useSelector(store => ({
        accountUser: store.AccountReducer.accountUser,
        producers: store.ContributorReducer.producers,
        contributors: store.ContributorReducer.contributors,
        contacts: store.ContactReducer.contacts,
        status: store.QualityReducer.status,
        qualifications: store.SuivipcReducer.qualifications,
        supports: store.SupportReducer.supports,
    }), shallowEqual)

    const createParameter = (parameter, value) => {
        return {
            login: accountUser.login,
            parameter,
            updateDate: moment().valueOf(),
            value,
        }
    }

    const showSandreCodeParameter = getSetting(accountUserSettings, SHOW_SANDRE_CODE)
    const showInseeCodeParameter = getSetting(accountUserSettings, SHOW_INSEE_CODE)
    const generalShowSandreCode = useApplicationSetting(SHOW_SANDRE_CODE, setting => setting ? parseInt(setting) : '1')
    const generalShowInseeCode = useApplicationSetting(SHOW_INSEE_CODE, setting => setting ? parseInt(setting) : '1')

    const LQCalculationOptions = [
        { value: '1', label: i18n.divideLQby2 },
        { value: '2', label: i18n.excludeResultsInfLQ },
        { value: '3', label: i18n.fixedValue },
    ]

    return (
        <Stack spacing={2}>
            <Accordion defaultExpanded>
                <AccordionSummary>{i18n.generalOptions}</AccordionSummary>
                <AccordionDetails>
                    <Grid container size={12}>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.displaySandreCode}
                                checked={(showSandreCodeParameter ?? generalShowSandreCode ?? '1') === '1'}
                                onChange={(e) => changeSetting(createParameter('showSandreCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.showInseeCode}
                                checked={(showInseeCodeParameter ?? generalShowInseeCode ?? '1') === '1'}
                                onChange={(e) => changeSetting(createParameter('showInseeCode', e ? '1' : '0'))}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded>
                <AccordionSummary>{i18n.qualityOptions}</AccordionSummary>
                <AccordionDetails>
                    <Grid container alignItems={'center'} size={12} spacing={1}>
                        <Grid size={12}>
                            <Typography sx={{ fontSize: 20 }}>{i18n.LQcalculationRule}</Typography>
                        </Grid>
                        <Grid container size={12} alignItems={'center'}>
                            <Grid size={6}>
                                <RadioButtons elements={ LQCalculationOptions } selected={ getSetting(accountUserSettings, 'TypeLimiteQuantification') || '1' }
                                    onChange={ (v) => changeSetting(createParameter('TypeLimiteQuantification', v)) }
                                />
                            </Grid>
                            { getSetting(accountUserSettings, 'TypeLimiteQuantification') === '3' ? (
                                <Grid size={2}>
                                    <NumberField title={ i18n.value } value={ getSetting(accountUserSettings, 'LQCalculationValue') }
                                        onChange={ (v) => changeSetting(createParameter('LQCalculationValue', v)) } floatValue
                                    />
                                </Grid>
                            ) : null }
                        </Grid>
                        <Grid size={12}>
                            <Typography sx={{ fontSize: 20 }}>{i18n.defaultValue}</Typography>
                        </Grid>
                        <Grid size={12}>
                            <Select
                                options={ producers }
                                label={ i18n.producer }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultProducer', v)) }
                                value={ getSetting(accountUserSettings, 'defaultProducer') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ contributors }
                                label={ i18n.sampler }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultSampler', v)) }
                                value={ getSetting(accountUserSettings, 'defaultSampler') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ contacts }
                                label={ i18n.contact }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultSamplerContact', v)) }
                                value={ getSetting(accountUserSettings, 'defaultSamplerContact') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ contributors }
                                label={ i18n.determiner }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultDeterminer', v)) }
                                value={ getSetting(accountUserSettings, 'defaultDeterminer') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ contacts }
                                label={ i18n.contact }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultDeterminerContact', v)) }
                                value={ getSetting(accountUserSettings, 'defaultDeterminerContact') }
                            />
                        </Grid>
                        <Grid size={12}>
                            <Select
                                options={ contributors }
                                label={ i18n.laboratory }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultLaboratory', v)) }
                                value={ getSetting(accountUserSettings, 'defaultLaboratory') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ status }
                                label={ i18n.status }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultStatus', v)) }
                                value={ getSetting(accountUserSettings, 'defaultStatus') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ qualifications }
                                label={ i18n.qualification }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultQualification', v)) }
                                value={ getSetting(accountUserSettings, 'defaultQualification') }
                            />
                        </Grid>
                        {/*
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.preservationMode }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultPreservationMode', v)) }
                                value={ getSetting(accountUserSettings, 'defaultPreservationMode') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.secondaryPreservationMode }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultSecondaryPreservationMode', v)) }
                                value={ getSetting(accountUserSettings, 'defaultSecondaryPreservationMode') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.clogging }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultClogging', v)) }
                                value={ getSetting(accountUserSettings, 'defaultClogging') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.cloggingType }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultCloggingType', v)) }
                                value={ getSetting(accountUserSettings, 'defaultCloggingType') }
                            />
                        </Grid>
                        <Grid size={12}>
                            <Select
                                options={ [] }
                                label={ i18n.material }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultMaterial', v)) }
                                value={ getSetting(accountUserSettings, 'defaultMaterial') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.accreditation }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultAccreditation', v)) }
                                value={ getSetting(accountUserSettings, 'defaultAccreditation') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.approval }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultApproval', v)) }
                                value={ getSetting(accountUserSettings, 'defaultApproval') }
                            />
                        </Grid>
                        <Grid size={12}>
                            <Select
                                options={ [] }
                                label={ i18n.protocol }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultProtocol', v)) }
                                value={ getSetting(accountUserSettings, 'defaultProtocol') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.development }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultDevelopment', v)) }
                                value={ getSetting(accountUserSettings, 'defaultDevelopment') }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.trust }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultTrust', v)) }
                                value={ getSetting(accountUserSettings, 'defaultTrust') }
                            />
                        </Grid> */}
                        {/*
                        <Grid size={6}>
                            <Select
                                options={ [] }
                                label={ i18n.seasonality }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultSeasonality', v)) }
                                value={ getSetting(accountUserSettings, 'defaultSeasonality') }
                            />
                        </Grid> */}
                        <Grid size={6}>
                            <Select
                                options={ supports }
                                label={ i18n.support }
                                nullLabel='&nbsp;'
                                onChange={ v => changeSetting(createParameter('defaultSupport', v)) }
                                value={ getSetting(accountUserSettings, 'defaultSupport') }
                            />
                        </Grid>
                        <Grid size={6}/>
                        <Grid size={6}>
                            <NumberField title={ i18n.creationMarginImportData } value={ getSetting(accountUserSettings, 'creationMarginImportData') }
                                onChange={ (v) => changeSetting(createParameter('creationMarginImportData', v)) }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.resumptionDataSiteRegardlessLocation}
                                checked={getSetting(accountUserSettings, 'resumptionDataSiteRegardlessLocation') === '1'}
                                onChange={(e) => changeSetting(createParameter('resumptionDataSiteRegardlessLocation', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.displayFollowUpTableReverseOrder}
                                checked={getSetting(accountUserSettings, 'displayFollowUpTableReverseOrder') === '1'}
                                onChange={(e) => changeSetting(createParameter('displayFollowUpTableReverseOrder', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.showOmnidiaCode}
                                checked={getSetting(accountUserSettings, 'showOmnidiaCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('showOmnidiaCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.viewMuseumNaturalHistoryCode}
                                checked={getSetting(accountUserSettings, 'viewMuseumNaturalHistoryCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('viewMuseumNaturalHistoryCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.viewMacrophyteCode}
                                checked={getSetting(accountUserSettings, 'viewMacrophyteCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('viewMacrophyteCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.viewAspeCode}
                                checked={getSetting(accountUserSettings, 'viewAspeCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('viewAspeCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.viewWormsCode}
                                checked={getSetting(accountUserSettings, 'viewWormsCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('viewWormsCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.showCASCode}
                                checked={getSetting(accountUserSettings, 'showCASCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('showCASCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.showSISEAUCode}
                                checked={getSetting(accountUserSettings, 'showSISEAUCode') === '1'}
                                onChange={(e) => changeSetting(createParameter('showSISEAUCode', e ? '1' : '0'))}
                            />
                        </Grid>
                        <Grid size={6}>
                            <Checkbox
                                label={i18n.displayAdvancedStatistics}
                                checked={getSetting(accountUserSettings, 'displayAdvancedStatistics') === '1'}
                                onChange={(e) => changeSetting(createParameter('displayAdvancedStatistics', e ? '1' : '0'))}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Stack>
    )
}

UserOptionPanel.propTypes = {
    accountUserSettings: PropTypes.arrayOf(PropTypes.instanceOf(DtoAccountSettings)),
    changeSetting: PropTypes.func,
}

export default UserOptionPanel
